enum ListSortFieldEnum {
    Amount = 'AMOUNT',
    Code = 'CODE',
    DischargeDate = 'DISCHARGE_DATE',
    Name = 'NAME',
    Rate = 'RATE',
    StartDate = 'START_DATE',
}

export default ListSortFieldEnum;
